import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {
  PlantModelElement,
  PlantGroupElement,
} from '../models/O3AdministrationModels/plant-model';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class CILDashboardService {
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getAMCIL(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'Dashboard/GetAMDashboard',
      data
    );
  }
  getCILDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetCILDashboard',
      data
    );
  }

  getNewCILDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetNewCILDashboard',
      data
    );
  }
  getDefectCILDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'NewDefectDashBoard/GetDashBoardChartData',
      data
    );
  }
  getAllListCilDasboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetAllListCilDasboard',
      data
    );
  }
  getFiveSDashboardData(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'AdminDashboard/GetAreaWithScore',
      data
    );
  }

  getFiveSDashboardDataPrev(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetLastAuditEecutionWithPer',
      data
    );
  }
  GetNewGembaWalkDash(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetNewGembaWalkDash',
      data
    );
  }
  getGembaReport(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetGembaReport',
      data
    );
  }

  getNoOf5sFindingOverall(data) {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'AdminDashboard/NoOf5sFindingOverall',
      data
    );
  }
  getNoOf5sFindingOverallPrev(data) {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'AdminDashboard/NoOf5sFindingOverallPrev',
      data
    );
  }

  getNewCilDashBoardReport(data)
  {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'CIL/GetNewCILDashboardReport',
      data
    );
  }
}
